import { Button } from "react-bootstrap";

const CustomAccordionToggle = ({ children, eventKey, onClick }) => {
  return (
    <Button type="button" variant="link" onClick={() => onClick(eventKey)}>
      {children}
    </Button>
  );
};

export default CustomAccordionToggle;
